import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSession } from "app/hooks/useSession";
import queryKeys from "shared/services/queryKeys";
import { useFlussCable } from "modules/fluss/hooks/useFlussCable";
import { myWorkApi, myWorkKeys, WorkScope } from "../services/my-work-api";

export const useMyWorkCount = () => {
    const client = useQueryClient();
    const { data: user } = useSession();
    const scope = (user?.workInboxScope || "mine_and_groups") as WorkScope;
    useFlussCable({ inbox: Boolean(user), onReceived: () => client.invalidateQueries({ queryKey: myWorkKeys.all }) });
    const count = useQuery({ queryKey: myWorkKeys.count(scope), queryFn: () => myWorkApi.getCount(scope),
        enabled: Boolean(user), refetchInterval: 60000, refetchOnWindowFocus: "always" });
    const setScope = async (next: WorkScope) => {
        const key = queryKeys.session.me();
        const prior = client.getQueryData<any>(key);
        client.setQueryData<any>(key, (old: any) => old ? { ...old, data: { ...old.data, work_inbox_scope: next } } : old);
        client.invalidateQueries({ queryKey: myWorkKeys.all });
        try {
            await myWorkApi.setPreference(next);
        } catch (error) {
            client.setQueryData(key, prior);
            client.invalidateQueries({ queryKey: myWorkKeys.all });
            throw error;
        }
    };
    return { count, scope, setScope };
};
